import React, { useState } from 'react';
import { BsArrowUp, BsArrowDown, BsArrowRight } from 'react-icons/bs';
import styles from './DataTable.module.css';

const DataTable = ({ data, onNoteClick }) => {
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending'
  });

  const getTrendIcon = (current, previous) => {
    if (!previous || current === 'Girilmedi' || previous === 'Girilmedi') return null;
    const currentValue = parseFloat(current);
    const previousValue = parseFloat(previous);
    
    if (currentValue > previousValue) {
      return <div className={`${styles.trendIcon} ${styles.trendUp}`}><BsArrowUp /></div>;
    } else if (currentValue < previousValue) {
      return <div className={`${styles.trendIcon} ${styles.trendDown}`}><BsArrowDown /></div>;
    }
    return <div className={`${styles.trendIcon} ${styles.trendNeutral}`}><BsArrowRight /></div>;
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue === 'Girilmedi') return 1;
      if (bValue === 'Girilmedi') return -1;

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
      }

      return sortConfig.direction === 'ascending'
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const getSortClassName = (key) => {
    if (!sortConfig.key || sortConfig.key !== key) return styles.sortable;
    return `${styles.sortable} ${sortConfig.direction === 'ascending' ? styles['sorted-asc'] : styles['sorted-desc']}`;
  };

  if (!data || data.length === 0) {
    return (
      <div className={styles.emptyState}>
        Görüntülenecek veri bulunamadı
      </div>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr>
            <th className={getSortClassName('donem')} onClick={() => requestSort('donem')}>
              Dönem
            </th>
            <th className={getSortClassName('hedef')} onClick={() => requestSort('hedef')}>
              Hedef
            </th>
            <th className={getSortClassName('gerceklesen')} onClick={() => requestSort('gerceklesen')}>
              Gerçekleşen
            </th>
            <th className={styles.tableHeaderCell}>
              Not
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => {
            const prevItem = index > 0 ? sortedData[index - 1] : null;
            const trendIcon = getTrendIcon(item.gerceklesen, prevItem?.gerceklesen);

            return (
              <tr key={item.donem} className={styles.tableRow}>
                <td className={styles.tableCell}>{item.donem}</td>
                <td className={`${styles.tableCell} ${styles.numeric}`}>
                  {typeof item.hedef === 'number' ? item.hedef.toLocaleString('tr-TR') : item.hedef}
                </td>
                <td className={`${styles.tableCell} ${styles.numeric} ${styles.withTrend}`}>
                  {typeof item.gerceklesen === 'number' ? item.gerceklesen.toLocaleString('tr-TR') : item.gerceklesen}
                  {trendIcon}
                </td>
                <td 
                  className={`${styles.tableCell} ${styles.noteCell}`}
                  onClick={() => onNoteClick(item.not)}
                >
                  {item.not}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable; 